import { nsDfs, nsPc } from "@qdabra/forms-shared/xmlNamespaces";
import FVNamespaceResolver from "../../../../fvNamespaceResolver"
import { NS_DOCUMENT_USER_KEY, NS_QDABRA_WEBSERVICE } from "./dbxl.helpers";

const makeQRulesNamespaceResolver = () => {
    const nsr = new FVNamespaceResolver();

    nsr.addNamespace('pc', nsPc);
    nsr.addNamespace('dfs', nsDfs);
    nsr.addNamespace("tns", NS_QDABRA_WEBSERVICE);
    nsr.addNamespace('qws', NS_QDABRA_WEBSERVICE);
    nsr.addNamespace("quk", NS_DOCUMENT_USER_KEY);

    return nsr;
}

const qRulesNamespaceResolver = makeQRulesNamespaceResolver();

export default qRulesNamespaceResolver;